import { createContext, useContext } from 'react';
import { Instance, types } from 'mobx-state-tree';

import { CriteriaStoreModel } from './Criteria';
import { StepStoreModel } from './Step';
import { UserDiscoveryResponseStoreModel } from './UserDiscoveryResponse';
import { UserPaymentStoreModel } from './UserPayment';
import { UserProgressStoreModel } from './UserProgress';
import { GroupStoreModel } from './Group';
import { OnboardingStoreModel } from './Onboarding';
import { PlanLabelsStoreModel } from './PlanLabels';

const RootModel = types
  .model({
    Step: StepStoreModel,
    Criteria: CriteriaStoreModel,
    UserDiscoveryResponse: UserDiscoveryResponseStoreModel,
    Group: GroupStoreModel,
    UserPayment: UserPaymentStoreModel,
    UserProgress: UserProgressStoreModel,
    Onboarding: OnboardingStoreModel,
    PlanLabels: PlanLabelsStoreModel,
  })
  .actions(() => ({
    afterCreate() {
      console.log('my-store, root afterCreate is called');
    },
  }));

export const rootStoreInitialState = RootModel.create({
  Step: {
    id: null,
    title: null,
    origin: null,
    steps: [],
  },
  Criteria: {
    criterias: [],
  },
  UserDiscoveryResponse: {
    userAnswers: [],
    userName: '',
    userEmail: '',
    userPhoneNumber: '',
    segment: null,
    groupId: null,
    utms: null,
    leadId: null,
    accountPicture: null,
    authToken: null,
    accountId: null,
    anonymousId: null,
  },
  Group: {
    groups: [],
  },
  UserPayment: {
    clientSecret: '',
    stripePlans: {},
    payPalPlans: {},
    discount: null,
    trialDays: 7,
    paypalClientId: '',
    paymentId: '',
    appliedCouponCode: null,
    planId: null,
    paymentComponentMetadata: {
      couponForm: {},
    },
  },
  UserProgress: {
    steps: [],
    backUrl: null,
  },
  Onboarding: {
    onboardingGoals: [],
  },
  PlanLabels: {
    allPlanLabels: {},
  },
});

export type RootInstance = Instance<typeof RootModel>;
const RootStoreContext = createContext<null | RootInstance>(null);
export const Provider = RootStoreContext.Provider;

export function useMst() {
  const store = useContext(RootStoreContext);
  if (store === null) {
    throw new Error('Store cannot be null, please add a context provider');
  }
  return store;
}
